import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import queryparse from 'tricks/string/queryparse';
import createLocation from 'utils/createLocation';
import { statusFilterOptions } from 'types/content';
import SelectField from 'components/Fields/SelectField';
import { jsx as _jsx } from "react/jsx-runtime";
function StatusFilter() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var location = useLocation();
  var queryParams = queryparse(location.search);
  var _queryParams$status = queryParams.status,
    selectedStatus = _queryParams$status === void 0 ? 'all' : _queryParams$status;
  function handleChange(_id, value) {
    navigate(createLocation(location.pathname, _objectSpread(_objectSpread({}, queryParams), {}, {
      status: value,
      page: undefined
    })), {
      replace: true
    });
  }
  var options = statusFilterOptions.map(function (_ref) {
    var value = _ref.value,
      labelTranslationKey = _ref.labelTranslationKey;
    return {
      value: value,
      title: t(labelTranslationKey)
    };
  });
  return /*#__PURE__*/_jsx(SelectField, {
    id: "status-filter",
    title: t('property_status_colon'),
    selectedValue: selectedStatus,
    onChange: handleChange,
    options: options,
    variant: "transparent",
    horizontal: true,
    horizontalLabelWidth: "auto",
    horizontalBreakpoint: "xxxs",
    bold: false
  });
}
export default StatusFilter;